module.exports = __webpack_public_path__ + "cert-secure.32907949298065999810825e3ef63c76.hashedasset.png";


//////////////////
// WEBPACK FOOTER
// ./app/img/layout/cert-secure.png
// module id = 4069087810086655
// module chunks = 1